import { CareRecipientId } from "./CareRecipientId";
import { CareRecipientName } from "./CareRecipientName";
import { DateObject } from "../fundamental/DateObject";
import { CareRecipientHouseId } from "./CareRecipientHouseId";
import { CustomerCode } from "./CustomerCode";
import { BranchCode } from "./BranchCode";

const CareRecipientType = Symbol();

export class CareRecipient {
    [CareRecipientType]: any;
    readonly id: CareRecipientId;
    readonly name: CareRecipientName;
    readonly birthday: DateObject | null;
    readonly houseId: CareRecipientHouseId | null;
    readonly customerCode: CustomerCode| null = null;
    readonly branchCode: BranchCode| null = null;

    private constructor(
        careRecipientId: CareRecipientId,
        careRecipientName: CareRecipientName,
        birthday: DateObject | null,
        houseId: CareRecipientHouseId | null,
        customerCode: CustomerCode| null,
        branchCode: BranchCode| null,
    ) {
        this.id = careRecipientId;
        this.name = careRecipientName;
        this.birthday = birthday;
        this.houseId = houseId;
        this.customerCode = customerCode;
        this.branchCode = branchCode;
    }

    static from(
        id: CareRecipientId,
        name: CareRecipientName,
        birthday: DateObject | null,
        houseId: CareRecipientHouseId | null,
        customerCode: CustomerCode| null = null,
        branchCode: BranchCode| null = null,
    ): CareRecipient {
        return new CareRecipient(id, name, birthday, houseId, customerCode, branchCode);
    }

    static fromIdNameHouseId(
        id: CareRecipientId,
        name: CareRecipientName,
        houseId: CareRecipientHouseId | null
    ): CareRecipient {
        return new CareRecipient(id, name, null, houseId, null, null);
    }
}

export type CareRecipientJsonArray = {
    id: string;
    name: string;
    houseId: string | null;
    alertPeriod: {
        start: string,
        end: string
    } | null;
    branchCode: string | null;
    customerCode: string | null;
};

export type CareRecipientJson = {
    id: string;
    name: string;
    birthday: string;
    houseId: string | null;
    customerCode: string | null;
    branchCode: string | null;
};

export type ViewableCareRecipientsJson = [{
    id: string,
    name: string,
    houseId: string,
}];

export type SimpleCareRecipient = Pick<CareRecipient, "id" | "name" | "houseId" | "customerCode" | "branchCode">
